import { personalData } from "../dataStore.js";

function Footer() {
  return (
    <div className="relative border-t bg-[#0d1224] border-[#353951] text-white">
      <div className="mx-auto px-6 sm:px-12 lg:max-w-[70rem] xl:max-w-[76rem] 2xl:max-w-[92rem] py-4 lg:py-10">
        <div className="flex justify-center -z-40">
          <div className="absolute top-0 h-[1px] w-1/2 bg-gradient-to-r from-transparent via-violet-500 to-transparent"></div>
        </div>
        <p className="text-sm text-center">
          © Developer Portfolio by{" "}
          <span className="text-[#16f2b3]">{personalData.name}</span>
        </p>
      </div>
    </div>
  );
}

export default Footer;
